module.exports = __webpack_public_path__ + "img/OMAR-GLAD.c87b1f0e.svg";